module.exports = __webpack_public_path__ + "img/used.18abdd3e.png";